import { NavigationSubItem } from "../navigation-item"

export class DesignSubItem extends NavigationSubItem {
  readonly id = "design"
  readonly label = "Design"
  readonly href = "/design"
  readonly iconName = "design-icon"
  readonly isExternal = false
  readonly tabs = []
}
